const SupplierDeliveryDates = (() => {
  const holidays = new Set([
    '2026-01-01','2026-01-26','2026-03-09','2026-04-03','2026-04-04','2026-04-05','2026-04-06','2026-04-25','2026-06-08','2026-09-25','2026-11-03','2026-12-25','2026-12-26','2026-12-28',
    '2027-01-01','2027-01-26','2027-03-08','2027-03-26','2027-03-27','2027-03-28','2027-03-29','2027-04-25','2027-06-14','2027-11-02','2027-12-25','2027-12-26','2027-12-27','2027-12-28'
  ]);
  const iso = date => date.toISOString().slice(0,10);
  function today(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-AU', {timeZone:'Australia/Melbourne',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
    const part = type => parts.find(p => p.type === type).value;
    return part('year') + '-' + part('month') + '-' + part('day');
  }
  function addBusinessDays(start, count) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(start) || !Number.isInteger(count) || count < 0 || count > 90) return null;
    const date = new Date(start + 'T12:00:00Z');
    if (!Number.isFinite(date.getTime()) || iso(date) !== start) return null;
    for (let remaining = count; remaining > 0;) {
      date.setUTCDate(date.getUTCDate() + 1);
      const day = iso(date);
      if (day < '2026-01-01' || day > '2027-12-31' || (day >= '2027-09-01' && day <= '2027-10-01')) return null;
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !holidays.has(day)) remaining--;
    }
    return iso(date);
  }
  function range(message, start = today()) {
    const match = String(message).match(/(\d+)\s*[–—-]\s*(\d+)\s+business\s+days/i);
    if (!match || Number(match[1]) > Number(match[2])) return null;
    const earliest = addBusinessDays(start, Number(match[1]) + 2);
    const latest = addBusinessDays(start, Number(match[2]) + 3);
    return earliest && latest ? {earliest, latest} : null;
  }
  function format(window) {
    const first = new Date(window.earliest + 'T12:00:00Z'), last = new Date(window.latest + 'T12:00:00Z');
    const sameYear = first.getUTCFullYear() === last.getUTCFullYear();
    const sameMonth = sameYear && first.getUTCMonth() === last.getUTCMonth();
    const full = date => new Intl.DateTimeFormat('en-AU',{timeZone:'UTC',day:'numeric',month:'long',...(!sameYear ? {year:'numeric'} : {})}).format(date);
    return (sameMonth ? first.getUTCDate() : full(first)) + '–' + full(last);
  }
  return {today, addBusinessDays, range, format};
})();
if (typeof module === 'object' && module.exports) module.exports = SupplierDeliveryDates;
(() => {
  if (typeof document === 'undefined') return;
  function refreshDelivery(notice) {
    if (window.Shopify?.country && window.Shopify.country !== 'AU') return;
    let rule;
    try { rule = JSON.parse(notice.dataset.supplierRule || '{}'); } catch { return; }
    if (rule.mode !== 'notice') return;
    const date = SupplierDeliveryDates.today();
    if (notice.dataset.deliveryDate === date) return;
    const windowDates = SupplierDeliveryDates.range(rule.message, date);
    if (!windowDates) return;
    const windowText = SupplierDeliveryDates.format(windowDates);
    const content = notice.querySelector('.supplier-notice__summary > div');
    if (!content) return;
    let estimate = content.querySelector('[data-supplier-delivery]');
    if (!estimate) {
      estimate = document.createElement('p');
      estimate.dataset.supplierDelivery = '';
      estimate.style.fontWeight = '600';
      content.querySelector('strong')?.after(estimate);
    }
    estimate.textContent = 'Estimated delivery: ' + windowText;
    const description = Array.from(content.querySelectorAll('p')).find(p => p !== estimate);
    if (description) description.textContent = 'Delivered by Australia Post.';
    const ack = notice.querySelector('input[type="checkbox"]');
    if (ack) {
      ack.value = rule.heading + ' — Estimated delivery: ' + windowText + '. I understand this is an estimated delivery window.';
      const label = ack.closest('label')?.querySelector('span');
      if (label) label.textContent = 'I understand the estimated delivery window.';
    }
    let property = notice.querySelector('[name="properties[Estimated delivery]"]');
    if (!property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = 'properties[Estimated delivery]';
      notice.append(property);
    }
    property.value = windowText;
    notice.dataset.deliveryWindow = windowText;
    notice.dataset.deliveryDate = date;
  }
  let queued = false, frame = null;
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; frame = requestAnimationFrame(update); }
  });
  function sync(form, checked) {
    form.querySelectorAll('.restock-rocket-acknowledgement-checkbox input[type="checkbox"]').forEach(input => {
      if (input.checked !== checked) {
        input.checked = checked;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll('.supplier-notice').forEach(refreshDelivery);
    document.querySelectorAll('product-form').forEach(form => {
      const notice = form.querySelector('.supplier-notice');
      if (!notice) return;
      form.dataset.supplierMode = 'notice';
      const ack = notice.querySelector('input[type="checkbox"]');
      const variant = form.querySelector('[name="id"]')?.value;
      if (form.dataset.supplierVariant && form.dataset.supplierVariant !== variant && ack) ack.checked = false;
      form.dataset.supplierVariant = variant || '';
      sync(form, ack ? ack.checked : true);
      form.querySelectorAll('.restock-rocket-preorder-button').forEach(button => {
        const span = button.querySelector('span');
        if (span && span.textContent !== 'Add to Cart') span.textContent = 'Add to Cart';
      });
    });
    observer.observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['value']});
  }
  function guard(event) {
    const pending = document.querySelector('[data-supplier-cart-pending="true"]');
    if (pending && (event.type==='submit' && event.target.id==='cart' || event.type==='click' && event.target.closest('[name="checkout"], a[href*="/checkout"]'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      document.querySelector('[data-supplier-cart-line] input[type="checkbox"]')?.focus();
      return;
    }
    const form = event.target.closest('product-form[data-supplier-mode="notice"]');
    if (!form) return;
    const ack = form.querySelector('.supplier-notice input[type="checkbox"]');
    if (!ack || ack.checked) return;
    if (event.type === 'click' && !event.target.closest('button[type="submit"], .restock-rocket-preorder-button, .shopify-payment-button, a[href*="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    ack.reportValidity(); ack.focus();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('.supplier-notice input[type="checkbox"]')) return;
    const form = event.target.closest('product-form');
    if (form) sync(form, event.target.checked);
    const line = event.target.closest('[data-supplier-cart-line]');
    if (line && event.target.checked) {
      event.stopImmediatePropagation();
      const input = event.target; input.disabled = true;
      const original = JSON.parse(line.dataset.supplierProperties || '{}') || {};
      const properties = Array.isArray(original) ? Object.fromEntries(original) : {...original};
      properties['Import notice acknowledged'] = input.value;
      const delivery = line.querySelector('.supplier-notice')?.dataset.deliveryWindow;
      if (delivery) properties['Estimated delivery'] = delivery;
      fetch(window.Shopify.routes.root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.dataset.supplierCartLine,quantity:Number(line.dataset.supplierQuantity),properties})})
        .then(response => { if (!response.ok) throw Error('Could not save acknowledgement'); return response.json(); })
        .then(cart => {if(!cart.items.some(item => item.properties?.['Import notice acknowledged']===input.value))throw Error('Acknowledgement was not saved'); window.location.reload();})
        .catch(() => {input.disabled=false;input.checked=false;line.querySelector('[role="status"]').textContent='Could not save acknowledgement. Please try again before checkout.';});
    }
  }, true);
  window.addEventListener('pagehide', () => { observer.disconnect(); if (frame !== null) cancelAnimationFrame(frame); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  update();
})();
